import React from 'react'
import Markdown from '../Markdown/markdown'
import Img from 'gatsby-image'
import './image-carousel.scss'
import ChevronIcon from '../../assets/icons/chevron-icon'

class ImageCarousel extends React.Component {

  state = {
    showImage: 0
  }

  renderPrev() {
    if (this.state.showImage > 0) {
      this.setState(prevState => ({showImage: prevState.showImage - 1}))
    } else if (this.state.showImage === 0) {
      this.setState({showImage: this.props.content.images.length - 1})
    }
  }

  renderNext() {
    if (this.state.showImage < this.props.content.images.length - 1) {
      this.setState(prevState => ({showImage: prevState.showImage + 1}))
    } else if (this.state.showImage === this.props.content.images.length - 1) {
      this.setState({showImage: 0})
    }
  }

  
  render () {
    const content = this.props.content
    
    if (content && content.images) {
      return (
        <div className="image-carousel-container">
          <div className="carousel-image-wrapper">
          {content.images.length > 1 ? <div className="show-arrows-desktop">
              <button className="carousel-pagination-arrow-btn" onClick={this.renderPrev.bind(this)}><ChevronIcon className="carousel-chevron" orientation="left"/></button>
              <button className="carousel-pagination-arrow-btn" onClick={this.renderNext.bind(this)}><ChevronIcon className="carousel-chevron"/></button>
            </div> : null}
            {content.images[this.state.showImage] && content.images[this.state.showImage].sizes ? <Img sizes={content.images[this.state.showImage].sizes} className="carousel-image"/> : null}
          </div>
          {content.images.length > 1 ? <div className="carousel-pagination">
            <button className="carousel-pagination-arrow-btn show-arrows-mobile" onClick={this.renderPrev.bind(this)}><ChevronIcon className="carousel-chevron" orientation="left"/></button>
            {content.images.map((image, i) => {
              return <button onClick={() => this.setState({showImage: i})} key={i} className={"btn-pagination " + (this.state.showImage === i ? "btn-pagination-active" : "")}>{(i+1)}</button>})}
            <button className="carousel-pagination-arrow-btn show-arrows-mobile" onClick={this.renderNext.bind(this)}><ChevronIcon className="carousel-chevron"/></button>
          </div> : null}
          <div className="carousel-content">
            { content.images[this.state.showImage] && content.images[this.state.showImage].title ? <h3 className="carousel-content-title">{content.images[this.state.showImage].title}</h3> : null}
            { content.images[this.state.showImage] && content.images[this.state.showImage].description ? <div className="carousel-content-description"><Markdown content={ content.images[this.state.showImage].description } /></div> : null}
          </div>
        </div>
      )
    } else {
      return null
    }
  }
}

export default ImageCarousel


// WEBPACK FOOTER //
// ./src/components/ImageCarousel/image-carousel.js